import { DisputesEdge } from '@varo/graphql-schema-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import StepChecklist from 'shared/components/vxl/ProgressIndicator/StepChecklist/StepChecklist';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import theme from 'shared/styles/theme';

import DisputesTransactionsList from './DisputesTransactionsList';

const DisputesItem = ({ item }: { item: DisputesEdge }) => {
  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'disputes',
  });
  return (
    <View style={styles.disputeContainer}>
      <View style={styles.claimContainer}>
        <StepChecklist
          key={item?.node?.id}
          stepperHeading={`${translatedText('claimHash')}${item?.node?.claimId}`}
          subHeading={item?.node?.accountNumberMasked}
          stepperStates={item?.node?.processSteps?.map((step) => {
            return {
              id: step?.title,
              stepState: step?.isComplete ? 'complete' : 'current',
              content: {
                descriptionText: step?.title,
                annotation: (
                  <BodySmText style={styles.annotationStyle}>
                    {step?.message}
                  </BodySmText>
                ),
              },
              indicator: {
                icon: step?.isComplete ? 'LIST_CHECK_MARK' : 'CIRCLE',
                tintColor: theme.color.interactive.primaryHovered,
              },
            };
          })}
        />
      </View>
      <SectionDivider
        labelText={translatedText('totalAmount', {
          numberOfCharges: item?.node?.numberOfCharges,
          charge:
            item?.node?.numberOfCharges === 1
              ? translatedText('charge')
              : translatedText('charges'),
          amount: item?.node?.disputedAmount?.formatted
            ? item.node.disputedAmount.formatted
            : null,
        })}
      />
      <DisputesTransactionsList disputesData={item} />
    </View>
  );
};

const styles = StyleSheet.create({
  annotationStyle: {
    color: theme.color.text.secondary,
  },
  claimContainer: {
    backgroundColor: theme.color.background.primary,
    borderColor: theme.color.border.primarySolid,
    borderRadius: 4,
    borderWidth: 1,
    marginHorizontal: theme.spacing.m,
    marginTop: theme.spacing.m,
  },
  disputeContainer: { marginBottom: theme.spacing.s },
});

export default DisputesItem;
